import { createContext, useContext } from 'react';
import {
  FEEDBACK_SUPPLIER_PROFILES,
  type FeedbackSupplierProfile,
} from '@erp/rpc';

/**
 * Whose Feedback card this is. The card's parts only need its name and how
 * the pricing team names its Results Workbook, so they read it from here
 * rather than through every Division card's props. Hubbell outside a card.
 */
export const FeedbackSupplierContext = createContext<FeedbackSupplierProfile>(
  FEEDBACK_SUPPLIER_PROFILES.hubbell,
);

export function useFeedbackSupplier(): FeedbackSupplierProfile {
  return useContext(FeedbackSupplierContext);
}
